export interface IUserSessionInfo {
  id?: string;
  userId: string;
  displayName?: string;
  phoneNumber?: string;
  imageUrl?: string;
  userName: string;
  email: string;
  domain: null;
  companyName: string;
  environment: string;
  version: string;
  companyId: string;
  firstLogin: boolean;
  release: string;
  settings: Record<string, Record<string, any>>;
}

export enum EdgeUserProfileStatus {
  None = "None",
  Active = "Active",
  Hidden = "Hidden",
  Deleted = "Deleted",
}

export enum EdgeSystemStatus {
  Initial = 0,
  Ongoing = 1,
  Success = 2,
  Error = 3
}

export interface EdgeUserProfile {
  id: string;
  name: string;
  rank: string;
  status: EdgeUserProfileStatus;
  image?: string;
}

export enum EdgeUserType {
  None = "None",
  Barge = "Barge",
  Customer = "Customer",
  Surveyor = "Surveyor",
}

export interface EdgeUser {
  id: string;
  displayName: string;
  userName: string;
  email: string;
  rank: string;
  vessel: string;
  roles: string[];
  userTypes: EdgeUserType[];
  profiles: EdgeUserProfile[];
  licenceNumber?: string | null;
}

export interface IEdgeUserSessionInfo extends IUserSessionInfo {
  edgeUser: EdgeUser | null;
}
